import React from "react";
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";
import {useAppState, useUserState} from "@stores/AppStateContext";

import {HeaderWithoutWorkspace} from "./HeaderWithoutLayout";
import {AddIcon} from "../../components/icons/AddIcon";
import {Button} from "../../components/Button";
import {EmptyPage} from '../../components/EmptyPage';
import {BadgeIcon} from "../../components/icons/BadgeIcon";

import {MODALS} from "../../screens/modals/modal-names";
import {screenSizeProvider} from "../../../stores/ScreenSizeProvider";

export const LayoutWithoutWorkspace = observer(() => {
    const appState = useAppState();
    const userState = useUserState();
    const isMobile = screenSizeProvider.view !== 'desktop';
    const isAdmin = userState!.isCurrentUserAdmin
    return (
        <div className="WithoutWorkspace-layout">
            {isAdmin ?
                <>
                    <HeaderWithoutWorkspace/>
                    <EmptyPage
                        isImportantTitle={true}
                        maxWidth={632}
                        title={intl.get('workspace.no_available_workspaces.title-forAdmin').d('Create workspace to get started!')}
                        text={intl.get('workspace.no_available_workspaces.text-forAdmin').d('Create workspaces organized by branch, department, team, project, location and other categories. Easily manage content across different areas of your business.')}
                        button={
                            <Button
                                fullWidth={isMobile}
                                Icon={AddIcon}
                                text={
                                    intl.get('workspace.no_available_workspaces.btn').d('Create a workspace')
                                }
                                onClick={() => appState.setModal({name: MODALS.CREATE_WORKSPACE, params: undefined})}
                            />}
                    />
                </> :
                <>
                    <HeaderWithoutWorkspace/>
                    <EmptyPage
                        Icon={BadgeIcon}
                        title={intl.get('workspace.no_available_workspaces.title.').d('You are currently not part of any workspace')}
                        text={intl.get('workspace.no_available_workspaces.text').d('Please contact your administrator to be added to a workspace or check back later.')}
                    />
                </>
            }
        </div>
    )
})
